import React from 'react';
import { Helmet } from 'react-helmet';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';

const Articles = () => {
    return (
        <div>
            <Helmet>
                <title>Articles | Biotech</title>
            </Helmet>
            <Navbar />

            <Footer />
        </div>
    );
};

export default Articles;